"use strict";
// The gap-inclusive figures (CR-002 CR2-020, CR2-022): over the gaps in scope, patients with no data
// count in the denominator; exclusions and exceptions are left out. #1 is inverse, so its numerator
// (poor control) is MET + INCOMPLETE and its open gaps are that numerator. Pure counts.
Object.defineProperty(exports, "__esModule", { value: true });
exports.gapFigures = gapFigures;
function gapFigures(counts, isInverse) {
    const denominator = counts.MET + counts.NOT_MET + counts.INCOMPLETE;
    const numerator = isInverse ? counts.MET + counts.INCOMPLETE : counts.MET;
    return {
        numerator,
        denominator,
        excluded: counts.EXCLUDED,
        exceptions: counts.EXCEPTION,
        openGaps: isInverse ? numerator : denominator - numerator,
        performanceRate: denominator === 0 ? null : (100 * numerator) / denominator,
    };
}
//# sourceMappingURL=figures.js.map